import Splide from '@splidejs/splide';

new Splide(".industries-splide", {
  type: "loop",
  perPage: 5,
  direction: document.documentElement.lang === "ar" ? "rtl" : "ltr",
  arrows: false,
  gap: "0.5rem",
  breakpoints: {
    1073: {
      perPage: 3,
    },
    982: {
      perPage: 2,
    },
    750: {
      perPage: 1,
    },
  },
  classes: {
    pagination: "splide__pagination paginate",
  },
}).mount()
